// extracted by mini-css-extract-plugin
module.exports = {"ellipsis-3-line":"Character_ellipsis-3-line__nH74b","hover-parent-active":"Character_hover-parent-active__58qZK","hover-parent":"Character_hover-parent__JLda3"};